import React from 'react';
import PropTypes from 'prop-types';

const PlayButton = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40px"
      height="40px"
      viewBox="0 0 38.697 38.697"
      fill={color}
      role="img"
    >
      <defs>
        <style />
      </defs>
      <title>Watch me3 Intro Video</title>
      <g transform="translate(-9 -961.362)">
        <path
          className="a"
          d="M28.349,961.362A19.349,19.349,0,1,0,47.7,980.711,19.363,19.363,0,0,0,28.349,961.362Zm0,1.888a17.461,17.461,0,1,1-17.461,17.461A17.447,17.447,0,0,1,28.349,963.25Zm-5.014,8.495A2.136,2.136,0,0,0,21.27,973.9v13.612a2.127,2.127,0,0,0,3.171,1.888l11.8-6.828a2.142,2.142,0,0,0,0-3.716l-11.8-6.828a2.206,2.206,0,0,0-1.106-.28Z"
        />
      </g>
    </svg>
  );
};

export default PlayButton;

PlayButton.propTypes = {
  color: PropTypes.string.isRequired,
};
